// remove end spaces
export function formatSearchParam(param: string) {
	return param.trim();
}
